module.exports = "/img/offroad_vehicle.53ba44f2.png";